const TOKEN_STORAGE_KEY = 'sc_userToken'
export const getUserToken = () => {
  // TODO add token logic
  return localStorage.getItem(TOKEN_STORAGE_KEY)
}

export const saveUserToken = (token) => {
  localStorage.setItem(TOKEN_STORAGE_KEY, token) // TODO proveriti da li da cuvamo u LS
}

export const removeUserToken = () => {
  localStorage.removeItem(TOKEN_STORAGE_KEY)
}
